import React, { FC } from 'react';
import Bugsnag from '@bugsnag/js';

import './setUp';

const BugSnagErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React);

const ErrorBoundary: FC<{ children }> = ({ children }) =>
  BugSnagErrorBoundary ? <BugSnagErrorBoundary>{children}</BugSnagErrorBoundary> : <>{children}</>;

export { ErrorBoundary };
